module.exports = __webpack_public_path__ + "static/img/banner_img_02.f8a9cf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/mobile/banner_img_02.png
// module id = 0HjA
// module chunks = 0